import { useState, useEffect } from "react";
import { Spin } from "antd";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { updateUser } from "scripts/reducer";
import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

import Footer from "components/footer/pwa";

import Logo from "images/logo.png";

const Component = ({ onUpdateUser, user }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded, title } = state;
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleLogout = () => {
		API.auth
			.logout()
			.then(() => {})
			.finally(() => {
				API.delCookie(process.env.REACT_APP_COOKIE_TOKEN);
				navigate("/");
			});
	};

	const componentDidUpdate = () => {
		switch (pathname) {
			case "/about":
				setState((prevState) => ({
					...prevState,
					title: Resources.aboutUs,
				}));
				break;
			case "/panel":
				setState((prevState) => ({
					...prevState,
					title: Resources.panelBk,
				}));
				break;
			case "/panel/account":
				setState((prevState) => ({
					...prevState,
					title: Resources.account,
				}));
				break;
			case "/panel/notifications":
				setState((prevState) => ({
					...prevState,
					title: Resources.notifications,
				}));
				break;
			case "/panel/bookmarks":
				setState((prevState) => ({
					...prevState,
					title: `${Resources.bookmark} ${Resources.ha}`,
				}));
				break;
			case "/panel/create":
				setState((prevState) => ({
					...prevState,
					title: `${Resources.add} ${Resources.job}`,
				}));
				break;
			case "/panel/jobs":
				setState((prevState) => ({
					...prevState,
					title: `${Resources.jobs} ${Resources.i}`,
				}));
				break;
			case "/panel/transactions":
				setState((prevState) => ({
					...prevState,
					title: `${Resources.transaction} ${Resources.ha}`,
				}));
				break;
			case "/panel/wallet":
				setState((prevState) => ({
					...prevState,
					title: Resources.wallet,
				}));
				break;
			case "/faq":
				setState((prevState) => ({
					...prevState,
					title: Resources.faq,
				}));
				break;
			case "/panel/payment-verification":
				setState((prevState) => ({
					...prevState,
					title: `${Resources.pay}${Resources.y}${Resources.ha}`,
				}));
				break;
			case "/support":
				setState((prevState) => ({
					...prevState,
					title: Resources.support,
				}));
				break;
			case "/contact":
				setState((prevState) => ({
					...prevState,
					title: Resources.contactUs,
				}));
				break;
			case "/terms":
				setState((prevState) => ({
					...prevState,
					title: Resources.terms,
				}));
				break;
			default:
				break;
		}
	};

	const componentDidMount = () => {
		const token = API.getCookie(process.env.REACT_APP_COOKIE_TOKEN);

		if (token) {
			API.auth
				.me()
				.then((user) => {
					onUpdateUser(user);

					setState((prevState) => ({
						...prevState,
						loaded: true,
					}));
				})
				.catch(() => {
					navigate("/auth/status");
				});
		} else {
			navigate("/auth/status");
		}
	};

	useEffect(componentDidUpdate, [pathname]);
	useEffect(componentDidMount, []);

	return loaded ? (
		<>
			<MediaQuery minWidth={992}>
				<div className="spa-panel-header">
					<div className="container">
						<h1 className="logo">
							<Link to="/">
								<img
									src={Logo}
									alt={Resources.bakelid}
								/>
								{Resources.bakelid}
							</Link>
						</h1>
						<span className="welcome">
							{`${user.fullName} ${Resources.welcome} `}
						</span>
						<Link
							to="/panel"
							className="user"
						>
							<Icons.Frame />
						</Link>
						<Link
							to="/panel/notifications"
							className="notif"
						>
							{user?.unreadNotificationsCount > 0 ? (
								<span className="badge">{user?.unreadNotificationsCount}</span>
							) : (
								""
							)}
							<Icons.Notification />
						</Link>
					</div>
				</div>
			</MediaQuery>
			<MediaQuery maxWidth={992}>
				<div className="pwa-panel-header">
					<div className="container">
						<span onClick={() => navigate(-1)}>
							<Icons.ArrowRight className="icon back" />
						</span>
						<h1 className="heading">{title}</h1>
					</div>
				</div>
			</MediaQuery>
			<div className="panel-body">
				<div className="container">
					<MediaQuery minWidth={992}>
						<div className="panel-sidebar">
							<ul className="links">
								<li
									className={`${pathname === "/panel/create" ? " active" : ""}`}
								>
									<Link to="/panel/create">
										<Icons.AddSquare />
										{Resources.add} {Resources.job}
									</Link>
								</li>
								<li
									className={`${pathname === "/panel/jobs" ? " active" : ""}`}
								>
									<Link to="/panel/jobs">
										<Icons.BriefCase />
										{Resources.jobs} {Resources.i}
									</Link>
								</li>
								<li
									className={`${
										pathname === "/panel/payment-verification" ? " active" : ""
									}`}
								>
									<Link to="/panel/payment-verification">
										<Icons.Moneys />
										{`${Resources.pay}${Resources.y}${Resources.ha}`}
									</Link>
								</li>
								<li
									className={`${
										pathname === "/panel/account" ? " active" : ""
									}`}
								>
									<Link to="/panel/account">
										<Icons.Frame />

										{Resources.account}
									</Link>
								</li>
								<li
									className={`${
										pathname === "/panel/bookmarks" ? " active" : ""
									}`}
								>
									<Link to="/panel/bookmarks">
										<Icons.SaveTick />
										{`${Resources.bookmark}${Resources.ha}`}
									</Link>
								</li>
								{/* <li
									className={`${pathname === "/panel/wallet" ? " active" : ""}`}
								>
									<Link to="/panel/wallet">
										<Icons.Wallet />

										{Resources.wallet}
									</Link>
								</li>
								<li
									className={`${
										pathname === "/panel/transactions" ? " active" : ""
									}`}
								>
									<Link to="/panel/transactions">
										<Icons.Moneys />
										{`${Resources.transaction}${Resources.ha}`}
									</Link>
								</li> */}
								<li
									className={`${
										pathname === "/panel/notifications" ? " active" : ""
									}`}
								>
									<Link to="/panel/notifications">
										<Icons.Notification />

										{Resources.notifications}
									</Link>
								</li>
								<li>
									<Link onClick={handleLogout}>
										<Icons.Logout />

										{Resources.logout}
									</Link>
								</li>
							</ul>
						</div>
					</MediaQuery>
					<div className="panel-content">
						{pathname === "/panel" && (
							<MediaQuery maxWidth={992}>
								<ul className="panel-nav">
									<li>
										<Link to="/panel/jobs">
											<Icons.BriefCase doutone="true" />
											{`${Resources.jobs} ${Resources.i}`}
										</Link>
									</li>
									<li>
										<Link to="/panel/bookmarks">
											<Icons.SaveTick doutone="true" />
											{`${Resources.bookmark}${Resources.ha}`}
										</Link>
									</li>
									<li>
										<Link to="/panel/account">
											<Icons.FrameRev doutone="true" />
											{Resources.account}
										</Link>
									</li>
									<li>
										<Link to="/panel/payment-verification">
											<Icons.Wallet doutone="true" />
											{`${Resources.pay}${Resources.y}${Resources.ha}`}
										</Link>
									</li>
									{/* <li>
										<Link to="/panel/wallet">
											<Icons.Wallet doutone="true" />
											{Resources.wallet}
										</Link>
									</li> */}
									{/* <li>
										<Link to="/panel/transactions">
											<Icons.Bill doutone="true" />
											{`${Resources.transaction}${Resources.ha}`}
										</Link>
									</li> */}
									<li>
										<Link to="/about">
											<Icons.Bill doutone="true" />
											{Resources.aboutUs}
										</Link>
									</li>
									<li>
										<Link to="/faq">
											<Icons.CircleInfo doutone="true" />
											{Resources.faq}
										</Link>
									</li>

									<li>
										<Link to="/terms">
											<Icons.Book doutone="true" />
											{Resources.terms}
										</Link>
									</li>
									<li>
										<Link to="/contact">
											<Icons.Calling doutone="true" />
											{Resources.contactUs}
										</Link>
									</li>
									<li>
										<Link to="/support">
											<Icons.Frame doutone="true" />
											{Resources.support}
										</Link>
									</li>
									<li>
										<Link to="/panel/notifications">
											<Icons.Notification doutone="true" />
											{Resources.notifications}
										</Link>
									</li>
									<li>
										<a
											href="https://bakelid.com/download/application/bakelid-release-v1.0.0.apk"
											target="_blank"
										>
											<Icons.ArrowDown doutone="true" />
											{`${Resources.download} ${Resources.direct} ${Resources.application}`}
										</a>
									</li>
									<li>
										<a
											href="https://play.google.com/store/apps/details?id=net.hoomaan.bakelid"
											target="_blank"
										>
											<Icons.ArrowDown doutone="true" />
											{`${Resources.receive} ${Resources.from} ${Resources.googlePlay}`}
										</a>
									</li>
									<li onClick={handleLogout}>
										<Link to="/">
											<Icons.Logout doutone="true" />
											{Resources.logout}
										</Link>
									</li>
								</ul>
							</MediaQuery>
						)}
						<Outlet />
					</div>
				</div>
			</div>
			<MediaQuery maxWidth={992}>
				<Footer />
			</MediaQuery>
		</>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect(
	(state) => {
		return {
			user: state.user,
		};
	},
	(dispatch) => {
		return {
			onUpdateUser: (data) => dispatch(updateUser(data)),
		};
	}
)(Component);
